import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaobloqueioveiculoprefaturas(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaobloqueioveiculoprefaturas/FIND_BLOQUEIOVEICULOS':
      case '@operacaobloqueioveiculoprefaturas/UPDATE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioveiculoprefaturas/DELETE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioveiculoprefaturas/STORE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioveiculoprefaturas/BLOQUEIOVEICULOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaobloqueioveiculoprefaturas/SUCCESS_REMOVE':
      case '@operacaobloqueioveiculoprefaturas/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaobloqueioveiculoprefaturas/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaobloqueioveiculoprefaturas;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaobloqueioveiculoprefaturas/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaobloqueioveiculoprefaturas;
        break;
      }

      case '@operacaobloqueioveiculoprefaturas/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
